
export type UpdateUserProfile200PreferencesTheme = typeof UpdateUserProfile200PreferencesTheme[keyof typeof UpdateUserProfile200PreferencesTheme];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateUserProfile200PreferencesTheme = {
  light: 'light',
  dark: 'dark',
  auto: 'auto',
} as const;
